


const HOME = ``
const ABOUT = `about`
const WORK = `our-works`
const EVENT = `events`
const CONTACT = `contact`
const TEAM = `team`



export {
    HOME,
    ABOUT,
    WORK,
    EVENT,
    CONTACT,
    TEAM
}